export default "__VITE_ASSET__CRCjN6mD__"